// extracted by mini-css-extract-plugin
export default {"host-image":"host-image_27gEw","hostImage":"host-image_27gEw"};